(function () {
  var STORAGE_KEY = 'retromaha:favorites:v1';

  function readFavorites() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(function (item) {
        return item && item.handle;
      });
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('retromaha:favorites:changed', { detail: { favorites: items } }));
  }

  function setButtonState(button, isSaved) {
    var title = button.getAttribute('data-product-title') || 'this product';
    var label = (isSaved ? 'Remove ' : 'Add ') + title + (isSaved ? ' from favorites' : ' to favorites');
    var visibleLabel = button.classList.contains('rm-favorite-button--product')
      ? isSaved
        ? 'SAVED TO FAVORITES'
        : 'ADD TO FAVORITES'
      : label;
    button.classList.toggle('is-active', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    button.setAttribute('aria-label', label);
    var labelNode = button.querySelector('[data-rm-favorite-label]');
    if (labelNode) labelNode.textContent = visibleLabel;
  }

  function syncUI() {
    var favorites = readFavorites();
    var handles = favorites.map(function (item) {
      return item.handle;
    });

    document.querySelectorAll('[data-rm-favorite-button]').forEach(function (button) {
      setButtonState(button, handles.indexOf(button.getAttribute('data-product-handle')) !== -1);
    });

    document.querySelectorAll('[data-rm-favorites-count]').forEach(function (count) {
      count.textContent = favorites.length;
    });

    document.querySelectorAll('[data-rm-favorites-link]').forEach(function (link) {
      link.setAttribute('aria-label', 'Favorites, ' + favorites.length + ' saved ' + (favorites.length === 1 ? 'item' : 'items'));
    });
  }

  function updateFavoritesEmptyState() {
    var page = document.querySelector('[data-rm-favorites-page]');
    if (!page) return;

    var grid = page.querySelector('[data-rm-favorites-grid]');
    var empty = page.querySelector('[data-rm-favorites-empty]');
    var status = page.querySelector('[data-rm-favorites-status]');
    var addAllButton = page.querySelector('[data-rm-favorites-add-all]');
    if (!grid || !empty || !status) return;

    var hasCards = grid.querySelector('[data-rm-favorite-card-item]');
    var hasFavorites = readFavorites().length > 0;
    status.hidden = true;
    empty.hidden = !!hasCards;
    if (addAllButton) addAllButton.hidden = !hasFavorites;
  }

  function removeFavoriteCard(button) {
    var card = button.closest('[data-rm-favorite-card-item]');
    if (!card) return false;

    card.classList.add('rm-favorite-card-removing');
    window.setTimeout(function () {
      card.remove();
      updateFavoritesEmptyState();
    }, 180);

    return true;
  }

  function toggleFavorite(button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var removedFromFavoritesPage = false;
    var favorites = readFavorites();
    var existingIndex = favorites.findIndex(function (item) {
      return item.handle === handle;
    });

    if (existingIndex > -1) {
      favorites.splice(existingIndex, 1);
      removedFromFavoritesPage = removeFavoriteCard(button);
    } else {
      favorites.unshift({
        handle: handle,
        title: button.getAttribute('data-product-title') || handle,
        url: button.getAttribute('data-product-url') || '/products/' + handle,
        addedAt: new Date().toISOString()
      });
    }

    writeFavorites(favorites);
    syncUI();
    if (!removedFromFavoritesPage) updateFavoritesEmptyState();
  }

  async function fetchFavoriteCard(handle) {
    var response = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=rm-favorite-card', { credentials: 'same-origin' });
    if (!response.ok) return '';

    var html = await response.text();
    var template = document.createElement('template');
    template.innerHTML = html.trim();
    var cardItem = template.content.querySelector('[data-rm-favorite-card-item]');

    return cardItem ? cardItem.outerHTML : '';
  }

  async function fetchAvailableVariantId(handle) {
    var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!response.ok) return null;

    var product = await response.json();
    if (!product || !Array.isArray(product.variants)) return null;

    var variant = product.variants.find(function (item) {
      return item && item.available;
    }) || product.variants[0];

    return variant ? variant.id : null;
  }

  function updateCartBubble(itemCount) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || typeof itemCount !== 'number') return;

    var bubble = cartLink.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(bubble);
    }

    var visibleCount = bubble.querySelector('[aria-hidden="true"]');
    var hiddenCount = bubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = itemCount < 100 ? itemCount : '';
    if (hiddenCount) hiddenCount.textContent = itemCount + ' items in cart';
  }

  async function addAllFavoritesToCart(button) {
    var favorites = readFavorites();
    var page = button.closest('[data-rm-favorites-page]');
    var status = page ? page.querySelector('[data-rm-favorites-cart-status]') : null;

    if (!favorites.length) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.hidden = false;
      status.textContent = 'Adding favorites to cart...';
    }

    var items = [];
    var skipped = 0;

    for (var i = 0; i < favorites.length; i += 1) {
      try {
        var variantId = await fetchAvailableVariantId(favorites[i].handle);
        if (variantId) {
          items.push({ id: variantId, quantity: 1 });
        } else {
          skipped += 1;
        }
      } catch (error) {
        skipped += 1;
      }
    }

    if (!items.length) {
      if (status) status.textContent = 'No favorites could be added to cart.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      return;
    }

    try {
      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!addResponse.ok) throw new Error('Cart add failed');

      try {
        var cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
        if (cartResponse.ok) {
          var cart = await cartResponse.json();
          updateCartBubble(cart.item_count);
        }
      } catch (error) {
        // The cart page will still reflect the update if the bubble refresh fails.
      }

      if (status) {
        status.textContent =
          'Added ' +
          items.length +
          ' favorite ' +
          (items.length === 1 ? 'item' : 'items') +
          ' to cart' +
          (skipped ? '. Skipped ' + skipped + ' missing ' + (skipped === 1 ? 'product' : 'products') + '.' : '.');
      }
    } catch (error) {
      if (status) status.textContent = 'Could not add favorites to cart. Please try again.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  async function renderFavoritesPage() {
    var page = document.querySelector('[data-rm-favorites-page]');
    if (!page) return;

    var grid = page.querySelector('[data-rm-favorites-grid]');
    var empty = page.querySelector('[data-rm-favorites-empty]');
    var status = page.querySelector('[data-rm-favorites-status]');
    var favorites = readFavorites();

    grid.innerHTML = '';
    empty.hidden = true;

    if (!favorites.length) {
      status.hidden = true;
      empty.hidden = false;
      updateFavoritesEmptyState();
      return;
    }

    status.hidden = false;
    status.textContent = 'Loading your favorites...';

    var renderedCount = 0;
    for (var i = 0; i < favorites.length; i += 1) {
      try {
        var cardHtml = await fetchFavoriteCard(favorites[i].handle);
        if (cardHtml) {
          grid.insertAdjacentHTML('beforeend', cardHtml);
          renderedCount += 1;
        }
      } catch (error) {
        // Product may have been removed or unpublished; skip it quietly.
      }
    }

    status.hidden = true;
    empty.hidden = renderedCount > 0;
    syncUI();
    updateFavoritesEmptyState();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rm-favorite-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    toggleFavorite(button);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rm-favorites-add-all]');
    if (!button) return;

    event.preventDefault();
    addAllFavoritesToCart(button);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncUI();
    renderFavoritesPage();
  });

  document.addEventListener('shopify:section:load', function () {
    syncUI();
    renderFavoritesPage();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      syncUI();
      renderFavoritesPage();
    }
  });

  window.addEventListener('retromaha:favorites:changed', syncUI);
})();
